<template>
  <div class="player">
    <audio id="js-player-audio">
      <source :src="currentAudio.url" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script>
import 'plyr/dist/plyr.css'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Player',
  data () {
    return {
      player: {},
      localCount: 0,
      localCurrentAudio: {}
    }
  },
  mounted () {
    const Plyr = require('plyr')
    const self = this

    self.player = new Plyr(document.getElementById('js-player-audio'), self.options)
    self.setListener()
  },
  computed: {
    ...mapState(['currentAudio', 'event', 'broadcast'])
  },
  watch: {
    currentAudio: function (val) {
      let currentAudio = this.localCurrentAudio
      if (val !== currentAudio) {
        currentAudio = val
        this.player.stop()
        this.player.source = this.setSource(currentAudio)
      }
    },
    event: function (val) {
      const player = this.player

      switch (val) {
        case 'Stop':
          player.stop()
          return
        case 'Paused':
          player.pause()
          return
        case 'Playing':
        case 'Play': // hack for always paly despite the same event
          player.play()
          return
        case 'toggle':
          player.togglePlay()
      }
    }
  },
  methods: {
    ...mapActions(['setEvent', 'setCurrentAudio']),
    setSource (audio) {
      return {
        type: 'audio',
        title: audio.title,
        sources: [
          {
            src: audio.url,
            type: 'audio/mp3'
          }
        ]
      }
    },
    setListener () {
      const self = this
      self.player.on('play', event => { self.onPlay() })
      self.player.on('pause', event => { self.onPause() })
      self.player.on('ended', event => { self.onEnded() })
    },
    onPlay () {
      this.setEvent('Playing')
    },
    onPause () {
      this.setEvent('Paused')
    },
    onEnded () {
      this.setEvent('Ended')
    }
  }
}
</script>

<style>
audio {
  margin:0 15px 0 14px;
  width:670px;
}

.now-play span {
  display:inline-block;
  font-size:1.05rem;
  vertical-align:top;
  padding:21px;
}

.np-action {
  width:30%;
}

.np-title {
  text-align:right;
  width:70%;
}

/* Plyr Overrides
================================================== */

.plyr--audio .plyr__controls {
  background-color:transparent;
  border:none;
  color:#fff;
  padding:20px 20px 20px 13px;
  width:100%;
}

.plyr--audio .plyr__controls button.tab-focus:focus,
.plyr--audio .plyr__controls button:hover,
.plyr__play-large {
  background:rgba(0,0,0,.1);
}

.plyr__progress--played,
.plyr__volume--display {
  color:rgba(0,0,0,.1);
}

.plyr--audio .plyr__progress--buffer,
.plyr--audio .plyr__volume--display {
  background:rgba(0,0,0,.1);
}

.plyr--audio .plyr__progress--buffer {
  color:rgba(0,0,0,.1);
}

</style>



// WEBPACK FOOTER //
// src/components/Player.vue